import dayjs from 'dayjs';
import axios from 'axios';

let utils = (function() {
  'use strict';

  // check is within radius
  function arePointsNear(checkPoint, centerPoint, km) {
    let ky = 40000 / 360;
    let kx = Math.cos((Math.PI * centerPoint.latitude) / 180.0) * ky;
    let dx = Math.abs(centerPoint.longitude - checkPoint.longitude) * kx;
    let dy = Math.abs(centerPoint.latitude - checkPoint.latitude) * ky;
    return Math.sqrt(dx * dx + dy * dy) <= km;
  }

  // json param is the standard json response from the backend that returns either success or not
  // if success then the onsuccesstxt will be shown with color green
  // if not then it will show the err msg from the backend with red color
  function notif(onsuccesstxt, json) {
    return {
      text: json.success ? onsuccesstxt : json.data.replace(/_/g, ' '),
      color: json.success ? 'green' : 'red'
    };
  }

  // generates the payload data from the form model
  // payload consists of key-values, the keys are based on the name of the model defined
  function toPayload(model) {
    let payload = {};
    for (let i = 0; i < model.length; ++i) {
      let val = model[i].value;
      // skip the null value
      if (typeof val !== 'boolean' && !val) {
        continue;
      }
      // skip if file
      if (model[i].type === 'file') {
        continue;
      }
      if (model[i].inputType) {
        if (model[i].inputType === 'date') {
          val = dayjs(val).format('YYYY-MM-DDTHH:mm:ssZ');
        } else if (model[i].inputType === 'number') {
          val = parseInt(val, 10);
        }
      }
      payload[model[i].name] = val;
    }
    return payload;
  }

  function toTimestamp(date) {
    return dayjs(date).format('YYYY-MM-DDTHH:mm:ssZ');
  }

  function nowToTimestamp() {
    return toTimestamp(dayjs());
  }

  // generates the model from the json from the backend with a given template
  function toModel(json, template) {
    let model = [];
    for (let k in template) {
      let item = template[k];
      item.name = k;
      let val = json ? json[k] : null;
      if (item.inputType && item.inputType === 'date') {
        val = val ? dayjs(val).format('YYYY-MM-DD') : '';
      } else if (item.type === 'autocompletelist' && !val) {
        val = [];
      } else if (item.type === 'array' && !val) {
        val = [];
      } else if (item.type === 'object' && !val) {
        // an object is a json array in this case
        // set the model from the template if null
        val = [];
        let it = {};
        for (let templ in item.template) {
          it[templ] = '';
        }
        val.push(it);
      }
      item.value = val;
      model.push(item);
    }
    return model;
  }

  // resets all model's values to null
  function resetModel(model) {
    for (let i = 0; i < model.length; ++i) {
      model[i].value = null;
    }
  }

  // generates the table data from a json with a given template
  function toTable(json, template) {
    let table = { data: [], title: [], hidden: [] };
    // set data
    for (let i = 0; i < json.length; ++i) {
      let item = { id: json[i].id, data: [] };
      for (let k in template) {
        let val = json[i][k];
        if (val !== null) {
          if (template[k].type && template[k].type === 'date') {
            val = dayjs(val).format('DD MMM YYYY');
          } else if (template[k].type && template[k].type === 'daterange') {
            let fmt = 'DD/MM';
            val = `${dayjs(val[0]).format(fmt)} - ${dayjs(
              val[val.length - 1]
            ).format(fmt)}`;
          } else if (template[k].type && template[k].type === 'bool') {
            val = val ? 'Yes' : 'No';
          } else if (template[k].join) {
            val = template[k].join(val);
          }
        } else if (template[k].default) {
          val = template[k].default;
        }
        item.data.push({ value: val });
        if (i === 0) {
          table.title.push(template[k].title);
        }
      }
      table.data.push(item);
    }
    return table;
  }

  // constructs a dropdown data
  function toDropdown(json, id, name) {
    let options = [];
    for (let i = 0; i < json.length; ++i) {
      let kv = { id: json[i][id], name: json[i][name] };
      options.push(kv);
    }
    return options;
  }

  function partialCopy(obj, keys) {
    let newObj = {};
    for (let i = 0; i < keys.length; ++i) {
      let key = keys[i];
      if (obj[key] !== null) {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  }

  return {
    notif,
    toPayload,
    toModel,
    resetModel,
    toTable,
    toDropdown,
    toTimestamp,
    nowToTimestamp,
    arePointsNear,
    partialCopy
  };
})();

let http = (function() {
  'use strict';

  function get(endpoint) {
    return processRequest(
      axios.get(mergeEndpoint(endpoint), {
        withCredentials: true
      })
    );
  }

  function post(endpoint, payload) {
    return processRequest(
      axios.post(mergeEndpoint(endpoint), payload, {
        withCredentials: true
      })
    );
  }

  function put(endpoint, payload) {
    return processRequest(
      axios.put(mergeEndpoint(endpoint), payload, {
        withCredentials: true
      })
    );
  }

  function del(endpoint) {
    return processRequest(
      axios.delete(mergeEndpoint(endpoint), {
        withCredentials: true
      })
    );
  }

  function processRequest(request) {
    return new Promise((resolve, reject) => {
      request
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response.status);
        });
    });
  }

  function mergeEndpoint(endpoint) {
    return `${process.env.VUE_APP_ROOT_API}${endpoint}`;
  }

  return {
    get,
    post,
    put,
    del
  };
})();

export { utils, http };
